import React from "react";
import { TextField, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export default function Field({
  value = "",
  handleChange,
  label,
  endIcon,
  startIcon,
  disabled,
  children,
  height,
  sx,
  size = "medium",
  select = false,
  error = false,
  helperText = "Error",
  labelStyle,
  onClick,
  inputStyle,
  filled = true,
  handleKeyChange,
  labelColor = "#616161",
  inputPropsSx,
  transform = "translate(13px,11.14px)",
  autoFocus = false,
  inputRef,
  labelFont = "16px",
  labelVariant = "body1",
  focusedIcon,
}) {
  const [isFocused, setIsFocused] = React.useState(false);

  return (
    <TextField
      inputRef={inputRef}
      autoFocus={autoFocus}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      variant="outlined"
      onKeyPress={handleKeyChange && handleKeyChange}
      select={select}
      label={
        isFocused
          ? label
          : label.length > 0 &&
            value.length === 0 && (
              <Typography
                variant={labelVariant}
                color={labelColor}
                fontWeight="400"
                fontSize={labelFont}
                lineHeight="24px"
              >
                {label}
              </Typography>
            )
      }
      value={value}
      onChange={handleChange}
      error={error}
      helperText={error ? helperText : ""}
      size={size}
      disabled={disabled}
      onClick={onClick}
      SelectProps={{
        IconComponent: KeyboardArrowDownIcon,
      }}
      inputProps={{
        style: {
          borderRadius: "3px",
          lineHeight: "20px",
          fontWeight: "400",
          fontSize: "14px",
          caretColor: error ? "#B00020" : "#255CCE",
          ...inputStyle,
        },
      }}
      InputLabelProps={{
        sx: {
          transform: isFocused ? "translate(14px, -8px) scale(0.72) !important" : transform,
          ...labelStyle,
        },
      }}
      InputProps={{
        endAdornment: !select && isFocused ? focusedIcon : endIcon,
        startAdornment: startIcon,
        sx: {
          backgroundColor:
            filled && value.length > 0 && !isFocused && !error && "#E9EFFA",
          "& .MuiOutlinedInput-input": {
            "-webkit-text-fill-color": error
              ? "#B00020 !important"
              : "#1f1f1f !important",
          },
          height: height,
          ...inputPropsSx,
        },
      }}
      sx={{
        display: "flex",
        width: "343px",
        borderRadius: "4px",
        backgroundColor: disabled && "#F5F5F5",
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor:
              filled && value.length > 0 && !isFocused && "primary.main",
          },
        },
        ...sx,
      }}
    >
      {children}
    </TextField>
  );
}
